<template>
    <slide-sheet v-model="isActive" :title="$t('param_label.likes', totalLikesCount, {count: totalLikesCount})" @closed="$emit('closed')" :width="420">
        <lazy-data-loader :url="props.url"
                        :params="params"
                        :simple-paginated="false"
                        on-scroll
                        v-model:total="totalLikesCount">

            <template #loading>
                <div v-for="likerLoader in Math.min(totalLikesCount, params.limit)" :key="'liker-loader-' + likerLoader" class="divided">
                    <profile-preview-skeleton flat no-spacing/>
                </div>
            </template>

            <template #default="{data}">
				<div v-for="liker in data" :key="`liker-${liker.id}`" class="divided">
					<profile-preview :model="liker" flat no-spacing/>
				</div>
			</template>

			<template #missing>
				<missing-info :text="$t('missing.data')"/>
			</template>

        </lazy-data-loader>
    </slide-sheet>
</template>

<script setup lang="ts">
import {ToggleableComponentEmits, type ToggleableComponentProps} from "../../types";
import {ref} from "vue";
import {useToggleableComponent} from "../../composables/useToggleableComponent";

const props = defineProps<{
	// The url where to load the likes from.
	url: string,

	// The predefined likes count if known
	count?: number,
} & ToggleableComponentProps>();

const emit = defineEmits([...ToggleableComponentEmits, 'closed']);

const params = {limit: 10}

const {isActive} = useToggleableComponent(props, emit);

const totalLikesCount = ref(props.count);

</script>